module.exports = __webpack_public_path__ + "static/img/b7_footer.730f518.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/core/b7_footer.png
// module id = 2pRR
// module chunks = 1